var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28865 -0.000976562L14.9587 -0.000976561C18.3487 -0.000976561 20.6187 2.37902 20.6187 5.91902L20.6187 14.09C20.6187 17.62 18.3487 19.999 14.9587 19.999L6.28865 19.999C2.89865 19.999 0.618652 17.62 0.618652 14.09L0.618652 5.91902C0.618652 2.37902 2.89865 -0.000976562 6.28865 -0.000976562ZM13.6283 12.9991C13.9683 12.6601 13.9683 12.1101 13.6283 11.7701L11.8483 9.99011L13.6283 8.20911C13.9683 7.87011 13.9683 7.31011 13.6283 6.97011C13.2883 6.62911 12.7383 6.62911 12.3883 6.97011L10.6183 8.74911L8.83826 6.97011C8.48826 6.62911 7.93826 6.62911 7.59826 6.97011C7.25826 7.31011 7.25826 7.87011 7.59826 8.20911L9.37826 9.99011L7.59826 11.7601C7.25826 12.1101 7.25826 12.6601 7.59826 12.9991C7.76826 13.1691 7.99826 13.2601 8.21826 13.2601C8.44826 13.2601 8.66826 13.1691 8.83826 12.9991L10.6183 11.2301L12.3983 12.9991C12.5683 13.1801 12.7883 13.2601 13.0083 13.2601C13.2383 13.2601 13.4583 13.1691 13.6283 12.9991Z",
    fill: "#F34235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/CloseSquare.24a67eafd7689d7dc322eb1805e0ab7b.svg";
export { ForwardRef as ReactComponent };